import { render, staticRenderFns } from "./MenuList.vue?vue&type=template&id=6db5020a&scoped=true"
import script from "./MenuList.vue?vue&type=script&lang=ts"
export * from "./MenuList.vue?vue&type=script&lang=ts"
import style0 from "./MenuList.vue?vue&type=style&index=0&id=6db5020a&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6db5020a",
  null
  
)

export default component.exports